import React from "react";
import { Flex } from "@chakra-ui/layout";
import nicoleAvatar from "../../images/nicole-avatar.jpg";
import fundacjaAvatar from "../../images/fundacja.svg";
import fb from "../../images/facebook.svg";
import insta from "../../images/instagram.svg";
import { Image, Text } from "@chakra-ui/react";


const profiles = [
  {
    img: nicoleAvatar,
    description: 'Mamaginekolog',
    facebookLink: 'https://www.facebook.com/mamaginekolog/',
    instagramLink: 'https://www.instagram.com/mamaginekolog/?hl=pl'
  },
  {
    img: fundacjaAvatar,
    description: 'Fundacja Ernesta',
    facebookLink: 'https://www.facebook.com/fundacjaernesta/',
    instagramLink: 'https://www.instagram.com/fundacjaernesta/?hl=pl'
  }
]

const openLink = (link: string) => {
  window.open(link)
}

export const Profiles = ({...props}, ) => (
  <Flex {...props} flexDirection="column" gridGap="14px">
    {
      profiles.map(({img, description, facebookLink, instagramLink}) => (
        <Flex justifyContent="space-between" alignItems="center" key={description}>
          <Flex gridGap="10px" alignItems="center">
            <Image borderRadius="50%" w='35px' h='35px' src={img}/>
            <Text fontSize="12px">{description}</Text>
          </Flex>
          <Flex gridGap="25px">
            <Image onClick={ () => openLink(instagramLink)} cursor="pointer" maxH="20px" src={insta} alt="instagram"/>
            <Image onClick={ () => openLink(facebookLink)} cursor="pointer" maxH="20px" src={fb} alt="facebook"/>
          </Flex>
        </Flex>
      ))
    }
  </Flex>
)
